import React, { useEffect, useState } from 'react';
import { Plus, Save, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { RichTextEditor } from '../../../components/RichTextEditor';
import { errMsg } from './crmConstants';

const EMPTY = { name: 'Nuovo template', subject: 'VocalFitness — ', body: '<p>Ciao {{name}},</p><p></p><p>— Il Team VocalFitness</p>' };
const VARS = '{{name}} {{englishLevel}} {{role}} {{sector}} {{company}} {{email}}';

export const EmailTemplatesDialog = ({ open, onClose, api, showToast, onChanged }) => {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState(null);
  const load = (keepId) => api.get('/admin/email-templates').then((t) => {
    setList(t);
    setSel(t.find((x) => x.id === keepId) || t[0] || null);
  });
  useEffect(() => { if (open) load(); }, [open]);

  const save = async () => {
    try {
      const payload = { name: sel.name, subject: sel.subject, body: sel.body };
      const saved = sel.id ? await api.put(`/admin/email-templates/${sel.id}`, payload) : await api.post('/admin/email-templates', payload);
      showToast('success', 'Template salvato'); load(saved.id); onChanged();
    } catch (e) { showToast('error', errMsg(e)); }
  };
  const remove = async () => {
    if (!sel.id || !window.confirm(`Eliminare il template "${sel.name}"? Lo storico degli invii resta.`)) return;
    await api.del(`/admin/email-templates/${sel.id}`); load(); onChanged();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl bg-slate-800 border-slate-700 text-white max-h-[92vh] overflow-y-auto z-[90]" data-testid="email-templates-dialog">
        <DialogHeader>
          <DialogTitle>Template email</DialogTitle>
          <DialogDescription className="text-slate-400">Crea e modifica i messaggi. Variabili sostituite in automatico: {VARS}</DialogDescription>
        </DialogHeader>
        <div className="grid md:grid-cols-[220px_1fr] gap-4">
          <div className="space-y-1.5">
            {list.map((t) => (
              <button key={t.id} onClick={() => setSel(t)} className={`w-full text-left px-3 py-2 rounded-lg text-sm ${sel?.id === t.id ? 'bg-amber-500 text-slate-950 font-semibold' : 'bg-slate-900 text-slate-200 hover:bg-slate-700'}`} data-testid={`etpl-item-${t.key}`}>
                {t.name}
              </button>
            ))}
            <button onClick={() => setSel({ ...EMPTY })} className="w-full flex items-center gap-1 px-3 py-2 rounded-lg text-sm text-amber-400 border border-dashed border-amber-500/40 hover:bg-amber-500/10" data-testid="etpl-new-btn"><Plus className="w-4 h-4" /> Nuovo template</button>
          </div>
          {sel ? (
            <div className="space-y-3">
              <input value={sel.name} onChange={(e) => setSel({ ...sel, name: e.target.value })} placeholder="Nome del template (es. Promemoria call)" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm" data-testid="etpl-name-input" />
              <input value={sel.subject} onChange={(e) => setSel({ ...sel, subject: e.target.value })} placeholder="Oggetto" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white text-sm font-semibold" data-testid="etpl-subject-input" />
              <div data-testid="etpl-body-editor"><RichTextEditor key={sel.id || 'new'} value={sel.body} onChange={(html) => setSel((s) => ({ ...s, body: html }))} minHeight={240} /></div>
              <div className="flex justify-between">
                <Button variant="ghost" onClick={remove} disabled={!sel.id} className="text-rose-400 hover:bg-rose-500/10" data-testid="etpl-delete-btn"><Trash2 className="w-4 h-4 mr-1" /> Elimina</Button>
                <Button onClick={save} disabled={!sel.name.trim() || !sel.subject.trim()} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="etpl-save-btn"><Save className="w-4 h-4 mr-1" /> Salva template</Button>
              </div>
            </div>
          ) : <p className="text-slate-500 text-sm">Seleziona un template</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
